export default "__VITE_ASSET__CTWLDgCh__"